console.log(
    "%cTheme made by coi - https://coi-agency.com",
    "font-size: 16px; color: #38c4f9; font-weight: bold;"
);


var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: true,
        passive: isScrollEvent,
      });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, {
        capture: false,
        passive: isScrollEvent,
      });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
      ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
          eventType
      ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent =
      ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !==
      -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, {
        capture: useCapture,
        passive: isScrollEvent,
      });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
        (!selector || selector === listener.selector) &&
        (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
          target.tagName &&
          ["button", "input", "select", "textarea"].indexOf(
              target.tagName.toLowerCase()
          ) > -1 &&
          target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
          // Check for match and fire
          // the event if there's one
          //
          // TODO:MCG:20120117: Need a way
          // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
        // Match the outer document (dispatched from document)
        element === document ||
        // The <html> element (dispatched from document.body or document.documentElement)
        element === document.documentElement ||
        // Or the window itself (dispatched from window)
        element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, {
        passive: true,
      });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key),
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach((callback) => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange) {
    this.settings();

    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      lap: "(min-width: 1025px) and (max-width: 1279px)",
      desktop: "(min-width: 1280px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
            new CustomEvent("breakpoint:changed", {
              detail: {
                previousBreakpoint: this.currentBreakpoint,
                currentBreakpoint: newBreakpoint,
              },
            })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
            new CustomEvent(`breakpoint:${key}`, {
              detail: {
                matches: isCurrentlyInBreakpoint,
              },
            })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false);

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="open-modal"]',
        this.openModal.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeModal.bind(this)
    );
    document.addEventListener(
        "posted_successfully",
        this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
        event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
        '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
        "--window-inner-height",
        `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
        "click",
        '[data-action="open-product-zoom"]',
        this.initPhotoSwipe.bind(this)
    );

    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--close",
        this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {

    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
        index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      index = this.slideshow.swiperElement.realIndex;
      index = this.slideshow.swiperElement.slides[index]
          .querySelector(".ProductSlider--Element")
          .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }


    this.createPhotoSwipeInstance(
        this.createPhotoSwipeItemsFromImages(images),
        parseInt(index)
    );
  }


  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
          maxHeight = parseInt(image.getAttribute("data-max-height")),
          maxDimension = new Responsive().matchesBreakpoint("phone")
              ? 1200
              : 2200,
          reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
        photoswipeContainer,
        false,
        items,
        {
          index: selectedImageIndex,
          showHideOpacity: true,
          showAnimationDuration: 500,
          loop: false,
          history: false,
          closeOnVerticalDrag: true,
          allowPanToNext: false,
          pinchToClose: false,
          errorMsg: '<p class="pswp__error-msg"></p>',
          scaleMode: "orig",
          getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
            if (isMouseClick) {
              return 1.35;
            } else {
              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            }
          },
          getThumbBoundsFn: function getThumbBoundsFn(index) {
            var allThumbnail = _this.element.querySelectorAll(
                    ".mainSwiper .ProductSliderCell--Zoom img"
                ),
                thumbnail = allThumbnail[index],
                pageYScroll =
                    window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        }
    );

    this.photoSwipeInstance.listen(
        "beforeChange",
        this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
        "destroy",
        this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
        "initialZoomIn",
        this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
        "initialZoomOut",
        this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
        "pswpTap",
        ".pswp__scroll-wrap",
        this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--close",
        this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--prev",
        this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
        "pswpTap",
        ".pswp__button--next",
        this.photoSwipeInstance.next
    );

    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--prev")
          .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--prev")
          .removeAttribute("disabled");
    }

    if (
        this.photoSwipeInstance.getCurrentIndex() + 1 ===
        this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--next")
          .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
          .querySelector(".pswp__button--next")
          .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
          .closest(".pswp")
          .querySelector(".pswp__ui")
          .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
          initialZoomLevel < 0.7 ? 1 : 1.33,
          point,
          333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;

    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
        ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
        ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
        ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
        "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
          "[name2=" + this.connectedSelect + "]"
      );
    }

    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
            ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(
            ".selectboxPageOverlay"
        );
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
        "click",
        "[data-action=toggle-selectbox]",
        this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
        "change",
        '[data-action="apply-sort"]',
        this.closeDropdown.bind(this, this.element)
    );

    this.domDelegate.on(
        "click",
        "[data-action=selectbox-submit]",
        this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
        "keypress",
        "[data-action=selectbox-submit]",
        this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
        "click",
        "[data-action=selectbox-change]",
        this.selectboxChange.bind(this)
    );

    this.delegateBody.on("selectors:close", this.onClickOutsideListener);

    this.delegateBody.on(
        "mouseover",
        '[data-action="close-selectors"]',
        this.closeSelectors.bind(this)
    );

    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  closeSelectors(event, target) {
    this.closeDropdown(this.element);
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
          .querySelector('[value="' + value + '"]')
          .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
        innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      this.element
          .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
          .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);

    if (
        !withinBoundaries ||
        event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
        dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
            '[selected="selected"]'
        ),
        titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
    );

    if(!target.closest('.header--links')){
      this.element.dispatchEvent(
          new CustomEvent("menu:close", { bubbles: true })
      );
    }


    bodyScrollLock.disableBodyScroll(target, bodyScrollLockOptions);

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
        target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
          .querySelector(".RevolutionSelectbox--Button")
          .setAttribute("aria-expanded", false);
      item
          .querySelector(".RevolutionSelectbox--Content")
          .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
          "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {

      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
          "click",
          this.onClickOutsideListener
      );
      const focus = this.element.querySelector("[data-scrollable]");
      if (!this.element.classList.contains("FilterBar")) {
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
        document.body.classList.add("scrollLock");
        trapFocus(this.mainDropdown);
      }
      if (
          document.querySelector("#Drawer").getAttribute("aria-expanded") ===
          "true"
      ) {
        document.querySelector(".Drawer--Wrapper").style.overflow = "visible";
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
        ".RevolutionSelectbox--Content"
    );

    const shadowElement = target.querySelector(".selectors-box-shadow");
    target.setAttribute("aria-expanded", "true");
    contentElement.style.display = "block";
    contentElement.style.height = `${contentElement.offsetHeight}px`;
    if (shadowElement) {
      setTimeout(() => {
        shadowElement.style.height = `${contentElement.offsetHeight}px`;
        shadowElement.style.display = "block";
      }, 200);
    }
    if (this.popover) {
      setTimeout(() => {
        contentElement.setAttribute("aria-hidden", "false");
      }, 20);
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");

    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
          "[aria-expanded='true']"
      ).parentElement;
    }

    closestDropdown
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
    closestDropdown
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
          ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);


    const shadowElement = target.querySelector(".selectors-box-shadow");

    if (shadowElement) {
      shadowElement.style.height = `0px`;
      shadowElement.style.display = "none";
    }

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
          "click",
          this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector("#Drawer");
      if (menuDrawer.getAttribute("aria-expanded") == "true") {
        document.querySelector(".Drawer--Wrapper").style.overflow = "auto";
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }
    }
    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);

    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
          formElement.name &&
          !formElement.disabled &&
          (formElement.checked ||
              /select|textarea/i.test(formElement.nodeName) ||
              /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                  formElement.type
              ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
        i = 0,
        _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        "[data-action=add-to-cart]",
        this.addToCart.bind(this)
    );
  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    var serialized = formHelper.serialize(formElement);

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === "page") {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: serialized.id,
                quantity: serialized.quantity,
              },
            })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
                .querySelector(".ProductForm--Error")
                .classList.add("visible");
            setTimeout(function () {
              _this.element
                  .querySelector(".ProductForm--Error")
                  .classList.remove("visible");
              addToCartButton.removeAttribute("disabled");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);

          } else {
            if (document.querySelector(".accent")) return;
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p3 accent ProductForm--Error";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton
                .closest("button")
                .insertAdjacentElement("afterend", errorMessageElement);
            _this.disableFunction = true;
            setTimeout(function () {
              errorMessageElement.remove();
              _this.disableFunction = false;
              addToCartButton.removeAttribute("disabled");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
      )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (!event.code) {
    } else {
      if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
    }
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
        (event.target === container || event.target === first) &&
        event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
        "click",
        "[data-action=toggle-dropdown]",
        this.toggleDropdown.bind(this)
    );

    let selector;

    switch (this.breakpoint) {
      case "lap_and_up":
        // For lap_and_up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  openDropdown(elem, target) {
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
          dropdown !== target.closest(".Dropdown") &&
          dropdown.querySelector("[aria-expanded='true']")
      ) {
        this.closeDropdown(dropdown);
      }
    });

    DropdownButton.setAttribute("aria-expanded", "true");

    new RevolutionAnimation(DropdownContent, "true").slideDown();

    setTimeout(() => {
      this.lock = false;
    }, 500);
  }

  closeDropdown(elem) {
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);

    setTimeout(() => {
      if (DropdownContent.getAttribute("aria-hidden") == "false") {
        DropdownContent.setAttribute("aria-hidden", "true");
        DropdownContent.classList.remove("show");
        const dataId = elem.getAttribute("data-id");

        const plusButton = elem.querySelector(".line_2");
        if (plusButton) {
          plusButton.style.height = "16px";
          plusButton.style.marginTop = "-7px";
        }
      }

      this.lock = false;
    }, 300);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";
    const dataId = target.getAttribute("data-id");
    const dropdownContent = mainDropdown.querySelector(".Dropdown--Content");

    if (!this.lock) {
      if (dataId == "mobile-menu" && isOpen) {
        const plusButton = target.querySelector(".line_2");
        plusButton.style.height = "16px";
        plusButton.style.marginTop = "-7px";
        dropdownContent.classList.remove("show");
        const items = mainDropdown.querySelectorAll(
            ".mobile_menu-dropdown-item"
        );
        items.forEach((item, index) => {
          item.style.animationDelay = `${index * 0.1}s`;
          item.style.transform = "translateX(-20px)";
        });
      } else if (dataId == "mobile-menu") {
        const plusButton = target.querySelector(".line_2");
        plusButton.style.height = "0px";
        plusButton.style.marginTop = "0px";
        dropdownContent.classList.add("show");
        const items = mainDropdown.querySelectorAll(
            ".mobile_menu-dropdown-item"
        );
        items.forEach((item, index) => {
          item.style.transform = "translateX(0)";
          item.style.animationDelay = `${index * 0.1}s`;
        });
      }
    }

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
        element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
          additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
        configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
          new CustomEvent("swiper:slide-changed", {
            bubbles: true,
            detail: {
              currentIndex: _this.swiperElement.activeIndex,
              element: _this.swiperElement.el[0],
            },
          })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.headerTransparent = document.body
        .querySelector("#header")
        .classList.contains("header--transparent")
        ? true
        : false;

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
        "click",
        '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
        this.openDrawer.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
        this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
        this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  maxHeight() {
    this.element.style.height = window.innerHeight + "px";

    if (
        this.element.getAttribute("id") == "cart" ||
        this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".cart-drawer_footer");

      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
        document.documentElement.style.setProperty(
            "--side-cart-footer",
            document.querySelector(".cart-drawer_footer").offsetHeight + "px"
        );
      }

      var headerEl = this.element.querySelector(".side-cart-header_wrapper");
      if (headerEl) {
        document.documentElement.style.setProperty(
            "--side-cart-header",
            document.querySelector(".side-cart-header_wrapper").offsetHeight + "px"
        );
        var header = headerEl.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".cart-items_wrapper");
      if (itemWrapper !== null) {
        itemWrapper.style.height =
            window.innerHeight - footerHeight - header - 24 + "px";

      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    if (this.headerTransparent) {
      document.body
          .querySelector("#header")
          .classList.remove("header--transparent");
    }

    this.headerScrolled = document.body
        .querySelector("#header")
        .classList.contains("header--scrolled")
        ? true
        : false;

    this.element.dispatchEvent(
        new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
        new CustomEvent("drawer:close-other", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
          new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }
    if (this.isOpen) {
      return;
    }

    if (this.element.getAttribute("data-id") == "mobile-menu") {
      const mobileMenuBackgorund = document.querySelector(
          ".mobile-menu_drawer_wrapper-first"
      );

      this.hamburger = document.body.querySelector(".header--hamburger");
      this.hamburger.classList.add("is-active");

      if (mobileMenuBackgorund) {
        mobileMenuBackgorund.classList.add("show");
        mobileMenuBackgorund.classList.remove("hide");
      }
    }

    this.maxHeight();
    if (this.element.getAttribute("id") == "Drawer") {
      if (document.querySelector(".Drawer--Close"))
        document.querySelector(".Drawer--Close").style.display = "flex";
      this.element.dispatchEvent(
          new CustomEvent("sidebar-drawer:open", {
            bubbles: true,
          })
      );
      document
          .querySelector("main-menu-dropdown .Drawer--Footer")
          .setAttribute("aria-expanded", true);
      document.documentElement.style.setProperty(
          "--menu-footer",
          document.querySelector("main-menu-dropdown .Drawer--Footer")
              .offsetHeight + "px"
      );
    }

    this.element.setAttribute("aria-expanded", "true");

    if (this.element.getAttribute("id") != "Drawer") {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this._closeListener);
    }
    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:close", {
          bubbles: true,
        })
    );
    if (this.element.getAttribute("id") == "Drawer") {
      document
          .querySelector("main-menu-dropdown .Drawer--Footer")
          .setAttribute("aria-expanded", false);
    }
    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element.setAttribute("aria-expanded", false);

      }
    }
    this.element.setAttribute("aria-expanded", "false");
    if (this.element.getAttribute("id") != "Drawer") {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this._closeListener);
    }
    removeTrapFocus(this.element);
    this.isOpen = false;
    this.onClose();

    if (this.element.getAttribute("data-id") == "mobile-menu") {
      const mobileMenuBackgorund = document.querySelector(
          ".mobile-menu_drawer_wrapper-first"
      );
      this.hamburger.classList.remove("is-active");

      if (mobileMenuBackgorund) {
        mobileMenuBackgorund.classList.remove("show");
        mobileMenuBackgorund.classList.add("hide");
      }
    }

    if (this.headerTransparent && !this.headerScrolled) {
      document.body
          .querySelector("#header")
          .classList.add("header--transparent");
    } else if (this.headerScrolled) {
      document.body
          .querySelector("#header")
          .classList.remove("header--transparent");
    }
  }

  translateTransitionEnded() {
    if (
        event.propertyName == "transform" &&
        this.element.getAttribute("aria-expanded") === "false"
    ) {
      if (this.element.getAttribute("id") == "mobile-menu") {
        this.element.dispatchEvent(
            new CustomEvent("menuDrawer:closed", { bubbles: true })
        );
        this.hamburger.style.pointerEvents = "all";
      }
      if (
          new Responsive().matchesBreakpoint("phone") &&
          this.element.id == "selectorsDrawer"
      )
        return;

      removeTrapFocus(this.element);
      this.element.style.display = "none";

      this.element.removeEventListener(
          "transitionend",
          this.transitionEndedListener
      );
    }
  }
}
class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate =
                  node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
        (results) => {
          const integer = options.integer;
          const elements = [];

          // Iterate over the IntersectionObserverEntry objects in the results array.
          results.forEach((result) => {
            // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
            if (result.isIntersecting || result.intersectionRatio > 0) {
              // Add the target element to the elements array.
              elements.push(result.target);
              // Unobserve the target element.
              this.intersectionObserver[integer].unobserve(result.target);
            }
          });

          // If there are no elements to reveal, return.
          if (elements.length === 0) {
            return;
          }

          // An object that maps each animation type to the corresponding animation function.
          const animations = {
            elementFromTop: "elementFromTop",
            elementFromBottom: "elementFromBottom",
            elementFromRight: "elementFromRight",
            elementFromLeft: "elementFromLeft",
            elementFromLeftBig: "elementFromLeftBig",
            elementFromRightBig: "elementFromRightBig",
            elementScaleIn: "elementScaleIn",
            elementScaleOut: "elementScaleOut",
          };

          // Get the animation function corresponding to the type from the animations object.
          const animation = animations[options.type];
          // If the animation function exists, call it with the elements array.
          if (animation) {
            this[animation](elements);
          }
        },
        { threshold: 0.1 }
    );

    if (animatedItem.classList.contains("animatedContent")) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll(".animatedContent").forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options["noVariants"] == "true") {
      this.toggleAddButton();
    }
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
        quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
      ? target.addEventListener(eventName, callback, false)
      : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
      options["hideElement"] || province_domid
  );

  Shopify.addListener(
      this.countryEl,
      "change",
      Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector(
        ".component-countDownWrapper"
    );

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options["countdownString"];
    counterString = counterString.replace(
        "{countdown}",
        '<span class="u-pb6 component-countDown">00:00:00</span>'
    );
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;

    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options["countdownType"] == "to_date") {
      countDate = new Date(this.options.countdownDate);
    }

    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;

    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);

    const [targetHours, targetMinutes] = this.options.countdownTime
        .split(":")
        .map(Number);
    if (
        targetHours < currentHours ||
        (targetHours === currentHours &&
            targetMinutes <= currentMinutes &&
            this.options["countdownType"] == "reccuring")
    ) {
      textDays = this.dayDifference - 1;
    } else if (this.options["countdownType"] == "reccuring") {
      textDays = this.dayDifference;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

var firstOpen = true;
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".cart-items-counter");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.loadedOnOpen = false;
    this.recommendationsLoaded = false;

    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }
    // Load recommendations if the option is enabled.
    if (this.options.showRecommendations && !this.recommendationsLoaded) {
      this.loadRecommendations();
      this.recommendationsLoaded = true
    }
    new AddToCart(this.element);
    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
          "click",
          '[data-action="update-item-quantity"], [data-action="remove-item"]',
          this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
          "change",
          '[data-action="update-change-quantity"]',
          this.updateItemQuantity.bind(this)
      );

      this.delegateElement.on(
          "keydown",
          '[data-action="update-change-quantity"]',
          this.preventEvent.bind(this)
      );

      this.delegateElement.on(
          "quantity:changed",
          ".QuantitySelector__CurrentQuantity",
          this.updateItemQuantity.bind(this)
      );
      document.addEventListener("cart:rerender", this.renderCart.bind(this));

      document.addEventListener("customer-type:changed", this.updateCartMonthlyRate.bind(this));

      window.theme.listener = "true";
    }
  }

  preventEvent(event, target) {
    if (event.which === 13 || event.keyCode === 13) {
      event.preventDefault();
      this.updateItemQuantity(event, target);
    }
  }

  onOpen() {
    // Get the value of the aria-expanded attribute.
    const isExpanded = this.element.getAttribute("aria-expanded") === "true";

    // Early exit if the drawer is already expanded.
    if (isExpanded) {
      return;
    }

    this.updateCartMonthlyRate();

    // Load recommendations if the option is enabled.
    if (this.options.showRecommendations && firstOpen == false && !this.recommendationsLoaded) {
      this.loadRecommendations();
      this.loadedOnOpen = true;
    }
    firstOpen = false;
    // // Calculate the height of the cart header and free shipping elements.
    // const cartHeader = document.querySelector(".cart-header");

    // const cartHeaderHeight = cartHeader ? cartHeader.offsetHeight : 0;

    // let totalHeight = cartHeaderHeight;

    // // Set the height of the cart header using a CSS variable.
    // /* if(window.theme.cartCount > 0 ){
    //    totalHeight = cartHeaderHeight;
    // }  */
    // document.documentElement.style.setProperty(
    //   "--cartHeader-height",
    //   totalHeight + "px"
    // );
  }

  waitForCartDomUpdate(cartRoot) {
    return new Promise((resolve) => {
      if (!cartRoot) return resolve();

      let done = false;

      const finish = () => {
        if (done) return;
        done = true;
        observer.disconnect();
        resolve();
      };

      const observer = new MutationObserver(() => {
        // cart DOM changed -> consider it updated
        // delay 1 frame so layout settles
        requestAnimationFrame(() => requestAnimationFrame(finish));
      });

      observer.observe(cartRoot, { childList: true, subtree: true });

      // hard timeout fallback (prevents getting stuck hidden)
      setTimeout(finish, 1500);
    });
  }


  updateItemQuantity(event, target) {
    event.preventDefault();

    const cartRoot =
        document.querySelector('.Cart') ||
        document.querySelector('[data-cart-root]') ||
        document.querySelector('#Cart') ||
        document.body;

    document.documentElement.classList.add('cart-updating');

    target
        .closest(".cartItem")
        .querySelector(".itemLoader")
        .classList.add("is-visible");

    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    let quantityChange = quantity != 0;

    // start observing BEFORE we trigger renderCart
    const domUpdated = this.waitForCartDomUpdate(cartRoot);

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
        .then(function () {
          _this.renderCart(target.getAttribute("data-id"), quantityChange);
          return domUpdated;
        })
        .then(function () {
          // Re-render VAT prices AFTER cart DOM is replaced
          const vat = document.querySelector('vat-controller');
          if (vat && typeof vat.renderAllPrices === 'function') {
            vat.renderAllPrices();
          }

          document.documentElement.classList.remove('cart-updating');
        })
        .catch(function () {
          document.documentElement.classList.remove('cart-updating');
        });
  }



  onProductAdded() {
    var _this = this;
    this.firstProductAdded = false;
    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  transformDrawerVatPrices(html) {
    const vatRate = parseFloat(window.theme?.vat?.ratePercent ?? 0) / 100;
    const type = localStorage.getItem('customer_type') || 'private';

    if (!vatRate || vatRate <= 0) return html;

    const wrap = document.createElement('div');
    wrap.innerHTML = html;

    wrap.querySelectorAll('.cart-drawer [data-vat-price][data-price-cents]').forEach((node) => {
      const base = parseInt(node.getAttribute('data-price-cents'), 10);
      if (!isFinite(base)) return;

      // private = original/base, business = remove VAT
      const value = (type === 'business')
          ? Math.round(base / (1 + vatRate))
          : base;

      node.textContent = window.Shopify?.formatMoney
          ? window.Shopify.formatMoney(value, window.theme?.moneyFormat)
          : (value / 100).toFixed(2);
    });

    // labels
    const showInc = type === 'private';
    wrap.querySelectorAll('.cart-drawer .vat-label--inc').forEach((el) => (el.style.display = showInc ? '' : 'none'));
    wrap.querySelectorAll('.cart-drawer .vat-label--ex').forEach((el) => (el.style.display = showInc ? 'none' : ''));

    return wrap.innerHTML;
  }




  renderCart(lineNumber, quantityChange) {
    firstOpen = false;
    this.pageLoader.style.width = "100%";

    let skipEvent = false;
    if (typeof event !== 'undefined' && event && event.type == "cart:rerender") {
      lineNumber = "CartItem-" + event.detail.lineItem;
      quantityChange = event.detail.quantityChange;
      skipEvent = true;
    }

    return fetch(window.routes.localeRootUrl + "/?section_id=main-cart_drawer", {
      credentials: "same-origin",
      method: "GET",
    })
        .then((res) => res.text())
        .then((html) => {
          const finalHtml = this.transformDrawerVatPrices(html); // <<< KEY
          this.replaceContent(finalHtml, lineNumber, quantityChange, skipEvent);
        });
  }


  updateCartMonthlyRate() {
    const el = this.element.querySelector('[data-cart-rate]');
    if (!el) return;

    const months = parseInt(el.getAttribute('data-months') || '0', 10);
    if (!Number.isFinite(months) || months <= 0) return;

    // Always read from current DOM (this updates after rerender)
    const totalNode = this.element.querySelector(
        '.side-cart_price_total [data-price-cents]'
    );

    const totalCents = totalNode
        ? parseInt(totalNode.getAttribute('data-price-cents') || '0', 10)
        : 0;

    if (!Number.isFinite(totalCents) || totalCents <= 0) {
      el.textContent = '';
      return;
    }

    const monthlyCents = Math.round(totalCents / months);

    el.textContent = `${window.Shopify?.formatMoney
        ? window.Shopify.formatMoney(monthlyCents, window.theme?.moneyFormat)
        : (monthlyCents / 100).toFixed(2)} `;
  }



  replaceContent(html, lineNumber, quantityChange, skipEvent) {

    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);

    var tempElement = new DOMParser().parseFromString(html, "text/html");

    this.tempOptions = JSON.parse(
        tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    this.options = this.tempOptions;



    if (this.firstProductAdded) document.dispatchEvent(_this.changeEvent);
    this.firstProductAdded = true;

    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = `${number}`;

    window.theme.cartCount = parseInt(number);
    this.updateCartNumber();
    if (lineNumber && tempElement.querySelector("#" + lineNumber)) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
          "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
            itemToReplaceWith,
            cartNodeParent.querySelector(".cartItem--Informations")
        );

      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
            [
              // keyframes
              { transform: "translateY(0px)", opacity: "1" },
              { transform: "translateY(30px)", opacity: "0" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);


        if (this.options["showRecommendations"]) {
          this.loadRecommendations();
        }
      }

      if (number > 0) {
        const footerTotal = this.element.querySelector(".CartFooter--Total");
        const footerTotalsToReplace = tempElement.querySelector(".CartFooter--Total");
        const footerTotalsParent = this.element.querySelector(".CartFooter--Totals");
        if (footerTotalsParent && footerTotalsToReplace && footerTotal) {
          footerTotalsParent.replaceChild(footerTotalsToReplace, footerTotal);

          // ✅ totals are in DOM now -> compute monthly rate now
          this.updateCartMonthlyRate();
        }


        const cartFreeShippingParent = this.element.querySelector(
            ".cartDrawer--freeShipping"
        );
        const cartFreeShippingToReplace = tempElement.querySelector(
            ".cartDrawer--freeShippingLeftContent"
        );

        const shippingBarTemp = tempElement.querySelector(
            ".cartDrawer--freeShippingLeftMoneyProgress"
        );
        const shippingBarCurrent = this.element.querySelector(
            ".cartDrawer--freeShippingLeftMoneyProgress"
        );

        if (cartFreeShippingToReplace) {
          cartFreeShippingParent.replaceChild(
              cartFreeShippingToReplace,
              cartFreeShippingParent.querySelector(
                  ".cartDrawer--freeShippingLeftContent"
              )
          );

          if (shippingBarTemp && shippingBarCurrent) {
            shippingBarCurrent.style.width = shippingBarTemp.style.width;
          } else if (shippingBarCurrent && !shippingBarTemp) {
            shippingBarCurrent.remove();
          } else {
            cartFreeShippingParent.append(
                tempElement.querySelector(
                    ".cartDrawer--freeShippingLeftMoneyProgressBar"
                )
            );
          }
        }
      } else {

        this.element
            .querySelector(".cart-drawer_footer")
            .classList.add("removing");
        this.recommendationsLoaded = false;
        const mainPartParent = this.element.querySelector(".cart-drawer");

        mainPartParent.innerHTML =
            tempElement.querySelector(".cart-drawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
              mainPartParent.querySelector("#main-cart_items");
          mainPartchildren.animate(
              [
                // keyframes
                { opacity: "0" },
                { opacity: "1" },
              ],
              {
                // timing options
                duration: 500,
                fill: "forwards",
              }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
              .querySelector(".itemLoader")
              .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
          this.element.querySelector(".cart-drawer").parentNode;
      const currentScrollPosition =
          this.element.querySelector("#main-cart_items").scrollTop;

      cartNodeParent.replaceChild(
          tempElement.querySelector(".cart-drawer"),
          this.element.querySelector(".cart-drawer")
      );
      this.element.querySelector("#main-cart_items").scrollTop =
          currentScrollPosition;
    }

    this.updateCartMonthlyRate();

    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }

    setTimeout(() => {
      if (!skipEvent) {
        var focus = _this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }
      _this.sidebarDrawer.maxHeight();
    }, 200);
  }

  updateCartNumber() {
    var number = this.tempOptions["itemCount"];
    let productsString = window.languages.products;
    const cartCountDrawer = this.element.querySelector(".cart-items-counter");

    if (cartCountDrawer) {
      cartCountDrawer.innerText = `(${number})`;
    }
  }

  loadRecommendations() {

    const _this = this;

    // Determine the URL to fetch recommendations based on the product ID option.
    const productId = this.options.productId;
    const url = productId
        ? `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=10`
        : "?section_id=helper-recommendations";

    // Fetch the recommendations and parse the HTML content.
    fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (content) {
          const container = document.createElement("div");
          container.innerHTML = content;

          // Insert the recommendations HTML into the recommendations container.
          const upsellContainer = container.querySelector(".cartUpsell");
          const recommendationsContainer = document.querySelector(
              ".cart-recommendations"
          );

          recommendationsContainer.innerHTML = upsellContainer.innerHTML;

          // Initialize the Swiper instance with the recommendations container and options.
          const swiper = new Swiper(
              recommendationsContainer.querySelector(".swiperUpsell"),
              {
                slidesPerView: 1,
                spaceBetween: 16,
                slidesOffsetAfter: 0,
                slidesOffsetBefore: 0,
                resistanceRatio: 0,
                loop: false,
                allowTouchMove: true,
                mousewheel: {
                  forceToAxis: true,
                },
                navigation: {
                  nextEl: ".swiperNextCart",
                  prevEl: ".swiperButtonPrevious",
                },
                breakpoints: {
                  1025: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    slidesOffsetAfter: 0,
                    slidesOffsetBefore: 0,
                  },
                },
              }
          );

          _this.recommendationsLoaded = true;
          // Dispatch a custom event to toggle favorites state.

          // Show the recommendations section and run the Revolution animation if enabled.

          const recommendationsSection = document.querySelector(
              ".cart-recommendations"
          );
          recommendationsSection.style.display = "flex";

          const cartDrawerRecommendation = document.querySelector(
              ".cart-recommendations"
          );

          let cartDrawerSlidesRecommendation = document.querySelectorAll(
              ".cart-recommendations .cartSlideItem"
          );
          if (cartDrawerSlidesRecommendation.length === 0) {
            cartDrawerRecommendation.style.display = "none";
          }
        })
        .catch(function (error) {
          // Handle the error gracefully by logging it or displaying an error message to the user.
          // For this implementation, we will not output errors to the console.
          // Instead, we can display an error message in the UI or send the error to a monitoring service.
        });
  }
}
customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);

    this.carouselElement = this.element.querySelectorAll(".swiper");
    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded = document.readyState === "complete";

    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onCssAndPageLoaded.bind(this));
    } else {
      this.onCssAndPageLoaded();
    }

    this.domDelegate.on(
        "click",
        "[data-action='open-collection']",
        this.openCollection.bind(this)
    );
  }

  openCollection(e) {
    const selectedTabOld = this.element.querySelector(
        `.tab-swiper[aria-selected='true']`
    );
    selectedTabOld.setAttribute("aria-selected", "false");
    e.target.setAttribute("aria-selected", "true");
    const collectionToBeOpenId = e.target.dataset.collectionOpen;
    const showCollection = this.element.querySelector(
        `#${collectionToBeOpenId}`
    );

    if (showCollection) {
      const collectionToBeClosed = this.element.querySelectorAll(
          ".FeaturedCollection--Wrapper"
      );
      collectionToBeClosed.forEach((collection) => {
        collection.style.display = "none";
        collection.style.opacity = "0";
      });

      showCollection.style.display = "block";
      setTimeout(() => {
        showCollection.style.opacity = "1";
      }, 200);
    }
  }
  onCssAndPageLoaded() {
    // Initialize Swiper only after the entire page (including CSS) is fully loaded
    this.carouselElement.forEach((swiper) => {
      this.carousel = new RevolutionSwiper(swiper);
    });
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
          this.element.querySelectorAll(".banner__image-container--swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
          cellElement.querySelectorAll(".banner__image-container--swap")
      );
    }
    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
        breakpoint === "pocket" ||
        breakpoint === "phone" ||
        breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".banner__image");
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1].querySelector(
            ".banner__image"
        );
      } else {
        imageToReveal = imageContainers[0].querySelector(
            ".banner__image"
        );
      }
    }
    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }
    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
    );
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = "true";
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.headerTransparent = false;
    const selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    this.bindEvents();
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
    );
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--sticky");
  }

  bindEvents() {
    if (this.options.transparent && this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);
    this.selectorsOpenedListener = this.openMenu.bind(this);

    this.delegateElement.on(
        "mouseenter",
        "[aria-hasMenu='true']",
        this.openMenu.bind(this),
        true
    );

    this.delegateElement.on(
        "focusin",
        "[aria-hasMenu='true']",
        this.openMenu.bind(this),
        true
    );

    this.delegateElement.on(
        "mouseleave",
        "[aria-submenu]",
        this.closeMenu.bind(this),
        true
    );

    this.delegateElement.on(
        "mouseenter",
        "[aria-singlemenu]",
        this.closeMenu.bind(this),
        true
    );

    this.delegateElement.on(
        "focusin",
        "[aria-singleMenu], .main-links",
        this.closeMenu.bind(this),
        true
    );

    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
        "--submenu-position",
        `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    if (this.element.classList.contains("header--transparent")) {
      this.element.classList.remove("header--transparent");
      this.headerTransparent = true;
    }

    target.setAttribute("aria-expanded", "true");

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
        (child) =>
            child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
        this.scrollableElement,
        bodyScrollLockOptions
    );

    let menuitems = target.querySelectorAll(".mainMenu--MultipleItems_Content");
    menuitems.forEach((item) => {
      const menu_sublinks = item.querySelectorAll(
          ".mainMenu--MultipleItems_subLink"
      );

      menu_sublinks.forEach((item, index) => {
        item.classList.add("show");
        const commonDuration = 300;
        const calculatedDelay = index * 150;
        const maxDelay = 250;
        const delay = Math.min(calculatedDelay, maxDelay);
        item.style.animationDuration = `${commonDuration}ms`;
        item.style.animationDelay = `${delay}ms`;
      });
    });
  }

  closeMenu(event, target) {
    const selectors = event.target.closest(".RevolutionSelectbox--Selectors");

    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }

    this.element.dispatchEvent(
        new CustomEvent("selectors:close", { bubbles: true })
    );

    let menuitems = target.querySelectorAll(".mainMenu--MultipleItems");
    menuitems.forEach((item) => {
      item.classList.remove(".show");
    });

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      if (event.target !== selectors) {
        item.setAttribute("aria-expanded", "false");
      }
    });
    this.toggleColor();

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("header--scrolled");
      this.element.classList.remove("header--transparent");
    } else {
      this.element.classList.remove("header--scrolled");
      this.element.classList.add("header--transparent");
    }
    if (this.options.transparent && this.headerTransparent) {
      this.element.classList.add("header--transparent");
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.isOpen = false;
    const allDrawer = this.element.querySelectorAll(".Drawer--wrapper");
    allDrawer.forEach((item) => {
      new Drawer(item);
    });

    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="toggle-subdrawer"]',
        this.toggleNextElement.bind(this)
    );

    this.delegateElement.on(
        "click",
        '[data-action="toggle-prev-subdrawer"]',
        this.togglePreviusElement.bind(this)
    );

    this.delegateBody.on(
        "sidebar-drawer:close",
        this.toggleElement.bind(this),
        true
    );
  }

  toggleElement(event, target) {
    this.isOpen = false;
    this.subdrawer = target.querySelectorAll(".SidebarDrawer--Wrapper");
    this.subdrawer.forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });
    this.subDropdownContent = document.querySelectorAll(
        ".sidebar--dropdown .Dropdown--Content"
    );
    this.subDropdownContent.forEach((item) => {
      item.setAttribute("aria-hidden", "true");
      item.style.height = "0";
      item.classList.remove("show");
    });
    this.subDropdown = document.querySelectorAll(".sidebar--dropdown .line_2 ");
    this.subDropdown.forEach((item) => {
      item.style.height = "16px";
      item.style.marginTop = "-7px";
    });
  }

  toggleNextElement(event, target) {
    if (this.isOpen) return;
    this.isOpen = true;
    event.preventDefault();
    let nextEl = target.getAttribute("data-toggle-id"),
        subdrawer = this.element.querySelector("#" + nextEl);

    subdrawer.style.display = "block";

    setTimeout(() => {
      subdrawer.setAttribute("aria-expanded", "true");
      const focus = subdrawer.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }, 15);
  }

  togglePreviusElement(event, target) {
    if (!this.isOpen) return;
    event.preventDefault();
    this.subdrawer = target.closest(".SidebarDrawer--Wrapper");
    this.subdrawer.setAttribute("aria-expanded", "false");

    this.subDropdown = document.querySelectorAll(
        ".sidebar--dropdown .Dropdown--Button "
    );
    this.subDropdown.forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });

    this.subDropdownContent = document.querySelectorAll(
        ".sidebar--dropdown .Dropdown--Content"
    );

    this.subDropdownContent.forEach((item) => {
      item.setAttribute("aria-hidden", "true");
      item.style.height = "0";
      item.classList.remove("show");
    });

    this.subDropdown = document.querySelectorAll(".sidebar--dropdown .line_2 ");
    this.subDropdown.forEach((item) => {
      item.style.height = "16px";
      item.style.marginTop = "-7px";
    });

    const focus = this.subdrawer.querySelector("[data-scrollable]");
    bodyScrollLock.enableBodyScroll(focus);
    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.subdrawer.addEventListener(
        "transitionend",
        this.transitionEndedListener
    );
  }

  translateTransitionEnded() {
    if (event.propertyName == "transform") {
      this.isOpen = false;
      this.subdrawer.style.display = "none";
      this.subdrawer.removeEventListener(
          "transitionend",
          this.transitionEndedListener
      );
    }
  }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
          "DOMContentLoaded",
          this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
        event.defaultPrevented ||
        event.ctrlKey ||
        event.metaKey ||
        !window.theme.showPageTransition ||
        !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
          this.pageOverlay,
          0.25,
          { autoAlpha: 0, ease: Linear.easeNone },
          { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
          this.element.dataset.position == 0 ||
          this.element
              .closest(".swiper-slide")
              .classList.contains("swiper-slide-active") ||
          this.element
              .closest(".swiper-slide")
              .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
        "swiper:slide-changed",
        this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
            this.element
                .querySelector("template")
                .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
        this.videoPlayer &&
        this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
          this.element
              .querySelector("template")
              .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["video_ratio"];
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
            100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["video_ratio"];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
              "https://www.youtube.com/watch?v=" +
              this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["video_ratio"];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
            100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["video_ratio"];
        }
        if (host == "youtube") {
          src =
              "https://www.youtube.com/watch?v=" +
              this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
        host === "youtube"
            ? "video/youtube"
            : host === "vimeo"
                ? "video/vimeo"
                : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "muteToggle",
          "fullscreenToggle",
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {

      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }

      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.muted("true");

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              console.log('playing');
              this.videoPlayer.play();
              if(!this.videoPlayer.el_.classList.contains("vjs-playing")){
                this.videoPlayer.el_.classList.remove("vjs-paused");
                this.videoPlayer.el_.classList.add("vjs-playing");
              }
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
          entry.intersectionRatio === 0 ||
          entry.isIntersecting == false
      ) {
        if (
            this.videoPlayer &&
            this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);


class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
        ".ProductSlider--Thumbnails"
    );
    this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
    );
    if(new Responsive().matchesBreakpoint("lap_and_up")){
      this.thumbnailsHeight();
    }
    if (this.options["slides_number"] > 1) {
      if (this.options["show_thumbnails"]) {
        this.carousel = new RevolutionSwiper(
            this.carouselElement,
            this.carouselElementThumbs
        );
      } else {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
        ".ProductOption--ValusWrapper"
    );

    new AddToCart(this.element);

    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.carouselElement, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    if (
        this.options["variant_image_id"] &&
        this.options["show_variant_image_on_load"]
    ) {
      this.updateImage();
    }

    if (this.options["sticky_atc"]) {
      this.stickyAtcWrapper = this.element.querySelector(
          ".product-module__sticky-atc"
      );

      this.mainAtc = this.element.querySelector(".ProductActions");
      this.footer = document.querySelector("#shopify-section-main-footer");
    }
    this.showStickyAtc();
    this.initialize();
    this.bindEvents();
  }

  thumbnailsHeight(){
    const imageElementHeight = this.element.querySelector('#productSwiperElement').offsetHeight;
    this.carouselElementThumbs.style.maxHeight = `${imageElementHeight}px`;

  }

  initialize() {
    this.addToCartBtn = this.element.querySelectorAll(".MainProduct--ATC");
    this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
    );
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));
    window.addEventListener("resize", () => {
      this.thumbnailsHeight();
    });

  }

  updateImage(event) {
    let imageID = this.options["variant_image_id"];
    if (event) {
      imageID = event.detail.new_image;
    }
    const selector = "#Image--" + imageID;
    const imageEl = this.element.querySelector(selector);

    const slideElement = imageEl.closest(".swiper-slide");
    const realIndex = Array.from(slideElement.parentNode.children).indexOf(
        slideElement
    );

    if (imageEl) {
      this.carousel.selectCell(realIndex);
    }
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
          .getAttribute("data-src")
          .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }


// Function to show or hide sticky ATC using IntersectionObserver
  showStickyAtc() {
    if (this.hideSticky) return;

    const options = {
      root: null, // viewport
      threshold: 0 // triggers as soon as any part is visible or hidden
    };

    // Create an IntersectionObserver for the footer
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // If footer is in view, hide sticky ATC
          this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
        } else {
          // If footer is not in view, check main ATC visibility
          if (this.mainAtcVisible) {
            this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
          } else {
            this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
          }
        }
      });
    }, options);

    // Create an IntersectionObserver for the main ATC
    const atcObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // If main ATC is in view, hide sticky ATC
          this.mainAtcVisible = true;
          this.stickyAtcWrapper.setAttribute("aria-hidden", "true");
        } else {
          // If main ATC is out of view, show sticky ATC
          this.mainAtcVisible = false;
          if (!this.footerVisible) {
            this.stickyAtcWrapper.setAttribute("aria-hidden", "false");
          }
        }
      });
    }, options);

    // Observe footer and main ATC
    footerObserver.observe(this.footer);
    atcObserver.observe(this.mainAtc);
  }
}

customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.atcButtons = document.querySelectorAll(".ProductPage--ATC");
    this.notifyButtons = document.querySelectorAll(
        ".product-module__product-atc-notify"
    );
    this.inStockContainer = document.querySelector(".product-module__in_stock");
    this.outOfStockContainer = document.querySelector(
        ".product-module__out-of-stock"
    );
    this.comingSoonContainer = document.querySelector(
        ".product-module__coming-soon"
    );

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });

    this.delegateBody.on('click', '[data-action="click-atc"]', this.clickAtc.bind(this));
  }

  clickAtc(event) {
    event.preventDefault();
    document.querySelector('.ProductActions .ProductPage--ATC.AddToCartAjax').click();
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
        this.querySelectorAll("select, input:checked"),
        (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
        new CustomEvent("variant:changed", {
          bubbles: true,
          detail: { new_image: newMedia },
        })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
        `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  transformVatPricesHtml(innerHtml) {
    const vatRate = parseFloat(window.theme?.vat?.ratePercent ?? 0) / 100;
    const includeTax = !!window.theme?.vat?.customerLoggedIn; // keeping your current meaning
    const type = localStorage.getItem('customer_type') || 'private';

    // discount
    let discountPercent = parseFloat(
        window.theme?.vat?.customer_discount ?? window.theme?.vat?.customerDiscount ?? 0
    );
    if (!Number.isFinite(discountPercent) || discountPercent < 0) discountPercent = 0;
    if (discountPercent > 100) discountPercent = 100;

    const hasDiscount = !!window.theme?.vat?.customerDiscount || discountPercent > 0;
    const discountEligible = hasDiscount && type === 'business' && discountPercent > 0;

    if ((!vatRate || vatRate <= 0) && !discountEligible) return innerHtml;

    const wrap = document.createElement('div');
    wrap.innerHTML = innerHtml;

    const isCompareAtNode = (node) => (
        node.hasAttribute('data-vat-no-discount') ||
        node.classList.contains('ProductInfo--CompareAtPrice') ||
        !!node.closest('.ProductInfo--CompareAtPrice') ||
        node.classList.contains('js-vat-compare') ||
        !!node.closest('.js-vat-compare') ||
        node.dataset.role === 'compare' ||
        node.hasAttribute('data-compare-price')
    );

    wrap.querySelectorAll('[data-vat-price][data-price-cents]').forEach((node) => {
      const base = parseInt(node.getAttribute('data-price-cents'), 10);
      if (!Number.isFinite(base)) return;

      // 1) discount first (only if eligible and not compare-at)
      let discounted = base;
      if (discountEligible && !isCompareAtNode(node)) {
        discounted = Math.round(base * (1 - discountPercent / 100));
      }

      // 2) VAT presentation
      let value = discounted;

      if (vatRate > 0) {
        if (includeTax) {
          if (type === 'business') value = Math.round(discounted / (1 + vatRate));
        } else {
          if (type === 'private') value = Math.round(discounted * (1 + vatRate));
        }
      }

      node.textContent = window.Shopify?.formatMoney
          ? window.Shopify.formatMoney(value, window.theme?.moneyFormat)
          : (value / 100).toFixed(2);
    });

    // Sync labels
    const showInc = type === 'private';
    wrap.querySelectorAll('.vat-label--inc').forEach((el) => (el.style.display = showInc ? '' : 'none'));
    wrap.querySelectorAll('.vat-label--ex').forEach((el) => (el.style.display = showInc ? 'none' : ''));

    return wrap.innerHTML;
  }



  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = ".ProductInfo--Prices";

          const html = new DOMParser().parseFromString(responseText, "text/html");
          const source = html.querySelector(id);
          if (!source) return;

          // Transform BEFORE injecting (prevents flash)
          const finalHtml = this.transformVatPricesHtml(source.innerHTML);

          const destinations = document.querySelectorAll(id);
          destinations.forEach((destination) => {
            destination.innerHTML = finalHtml;
          });

          const calcPopup = document.querySelector("calculator-popup")

          const ratePrices = document.querySelector(".monthly-payment-wrapper__price-info");
          if(ratePrices){
            const newRatePrices = html.querySelector('.monthly-payment-wrapper__price-info')
            ratePrices.innerHTML =  newRatePrices.innerHTML;
          }


          if(calcPopup){
            const newCaclPopup = html.querySelector("calculator-popup")
            calcPopup.innerHTML =  newCaclPopup.innerHTML;
          }


          // Quantity handler replacement (unchanged)
          const quantityButton = document.querySelector(".QuantityHandler");
          if (quantityButton) {
            const srcQty = html.querySelector(".QuantityHandler");
            if (srcQty) quantityButton.innerHTML = srcQty.innerHTML;
          }

          this.toggleAddButton();


          document.dispatchEvent(new CustomEvent('prices:changed', {
            detail: { variantId: this.currentVariant.id },
          }));

        });
  }


  toggleAddButton() {
    let hideButtons = document.querySelectorAll(".hideBtn");
    hideButtons.forEach(function (button) {
      button.classList.remove("hideBtn");
    });
    let quantity = "";
    const addButton = document.querySelectorAll(".ProductPage--ATC"),
        quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");
    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (this.currentVariant.available == false) {
      addButton.forEach((button) => {
        button.classList.add("hideBtn");
      });
      if (this.inStockContainer) {
        this.inStockContainer.classList.add("hideBtn");
      }
    } else {
      if (this.outOfStockContainer) {
        this.outOfStockContainer.classList.add("hideBtn");
      } else {
        this.comingSoonContainer.classList.add("hideBtn");
      }

      addButton.forEach((button) => {
        button.dataset.action = 'add-to-cart';
        if (button.classList.contains('product-module__product-atc--sticky')) {
          button.dataset.action = 'click-atc';
        }

        button.classList.remove("hideBtn");
      });
    }
    this.showNotifyMeButton(this.currentVariant.available);
  }

  showNotifyMeButton(available) {
    if (!this.notifyButtons) return;

    if (available) {
      this.notifyButtons.forEach((btn) => (btn.style.display = "none"));
      this.atcButtons.forEach((btn) => (btn.style.display = "block"));
    } else {
      this.notifyButtons.forEach((btn) => (btn.style.display = "block"));
      this.atcButtons.forEach((btn) => (btn.style.display = "none"));
    }
  }

  getVariantData() {
    this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".search-wrapper");
    this.pageOverlayElement = this.element.querySelector(
        ".search__page-overlay"
    );
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);

    this.headerTransparent = false;
    this.carouselElement = this.element.querySelector(".search-initial");
    if (this.carouselElement) {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
        "--search-header-height",
        `${this.searchInputElement.offsetHeight + 48}px`
    );

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
        "click",
        '[data-action="open-search"]',
        this.openSearch.bind(this)
    );

    this.delegateElement.on(
        "click",
        '[data-action="close-search"]',
        this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
        "click",
        '[data-action="search-string"]',
        this.onInput.bind(this)
    );

    this.delegateElement.on(
        "keypress",
        '[data-action="search-string"]',
        this.onInput.bind(this)
    );

    this.delegateElement.on(
        "click",
        '[data-action="search-template"]',
        this.trigerEnter.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  trigerEnter(){

    if (this.searchInputElement) {
      // Create a new KeyboardEvent for the 'Enter' key
      const enterEvent = new KeyboardEvent('keydown', {
        key: 'Enter',
        code: 'Enter',
        keyCode: 13, // Deprecated, but still works in some browsers
        which: 13,   // Deprecated, but still works in some browsers
        bubbles: true
      });

      // Dispatch the keydown event
      this.searchInputElement.dispatchEvent(enterEvent);


      if (this.searchInputElement.form) {
        this.searchInputElement.form.submit();
      }
    }
  }

  initCarousel() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      var carousel = this.searchResultsElement.querySelector(
          "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
          var _len = arguments.length, args = Array(_len), _key = 0;
          _key < _len;
          _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.style.display = "block";

    this.element.dispatchEvent(
        new CustomEvent("menu:close", { bubbles: true })
    );

    this.element.dispatchEvent(
        new CustomEvent("drawer:close-other", { bubbles: true })
    );
    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }

    // Show search element and page overlay
    const search = document.querySelector("#search");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }
    this.pageOverlayElement.classList.add("is-visible");
    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
    );

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    if (
        document.querySelector(".header--transparent") &&
        new Responsive().matchesBreakpoint("lap_and_up")
    ) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("header--transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();

    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
    );
    this.element.setAttribute("aria-hidden", true);
    const transitionElement = this.element.querySelector(
        ".search-inner_wrapper"
    );

    const transitionEndHandler = () => {
      if (this.headerTransparent && this.headerTransparent) {
        document.body
            .querySelector("#header")
            .classList.add("header--transparent");
      }
      this.element.style.display = "none";
      transitionElement.removeEventListener(
          "transitionend",
          transitionEndHandler
      );
    };

    transitionElement.addEventListener("transitionend", transitionEndHandler);

    this.pageOverlayElement.classList.remove("is-visible");
    this.resetSearch();
    this.isOpen = false;
  }

  async onInput(event) {

    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".search-wrapper");
    this.searchResultsElement.style.opacity = 0;

    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {

      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".search__input");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
          `${routes.predictive_search_url}?q=${encodeURIComponent(
              this.lastInputValue
          )}&resources[limit_scope]=each&section_id=search-predictive&resources[options][fields]=title,product_type,variants.title,body,tag,vendor`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-search-predictive").innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector("template");
      const currentSuggestedQueries = this.element.querySelector(
          ".predictive-search_queries"
      );

      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();

      if (suggestedQueries) {
        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries.content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      this.searchResultsElement.style.opacity = 1;
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }
  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector(
        ".predictive-search_queries"
    );
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
            "searchTerms",
            JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
        "change",
        "[data-state='required']",
        this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".contact-btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".contact-btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
          'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
          this.renderPreview(sectionInnerHTML);
        })
        .catch((e) => {
          this.renderError();
        });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
        sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        "[data-action='update-note']",
        this.updateNote.bind(this)
    );

    this.delegateElement.on(
        "click",
        "[data-action='edit-note']",
        this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
        this.element.getAttribute("data-section-settings")
    );

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      document.addEventListener("scroll", this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");

      document.body.classList.add("scrollLock");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
          "click",
          '[data-action="close-modal"]',
          this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    event.preventDefault();

    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();
    document.body.classList.remove("scrollLock");

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);

class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"));
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
        "click",
        '[data-action="toggle-tab"]',
        this.toggleTab.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="submit-login"]',
        this.submitLogin.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="submit-register"]',
        this.submitRegistration.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="toggle-recovery"]',
        this.toggleRecovery.bind(this)
    );
    this.delegateElement.on(
        "click",
        '[data-action="submit-recovery"]',
        this.accountRecover.bind(this)
    );
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == "recoverFlex") {
      this.element
          .querySelector("#recoverFlex")
          .setAttribute("aria-visible", "true");
      this.element
          .querySelector("#loginFlex")
          .setAttribute("aria-visible", "false");
    } else {
      this.element
          .querySelector("#recoverFlex")
          .setAttribute("aria-visible", "false");
      this.element
          .querySelector("#loginFlex")
          .setAttribute("aria-visible", "true");
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account/recover";

    // Check if hCaptcha exists, if yes, execute it
    if (window.hcaptcha) {
      // Manually trigger the hCaptcha
      window.hcaptcha.execute();

      // Add a delay and wait for the CAPTCHA to finish, then retrieve the response
      const interval = setInterval(function () {
        const captchaToken = window.hcaptcha.getResponse(); // Get the hCaptcha token

        if (captchaToken) {
          clearInterval(interval); // Stop checking once the token is available

          // Create the request body with the email and hCaptcha token
          const requestBody = {
            email: _this.element.querySelector("#RecoverEmail").value, // Use _this for class scope
            'h-captcha-response': captchaToken // Include hCaptcha token here
          };

          event.target.querySelector(".itemLoader").classList.add("is-visible");

          // Send the AJAX request
          (async function () {
            try {
              const response = await fetch(registrationEndpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
              });

              const responseText = await response.text();
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = responseText;

              if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
                _this.element.querySelector(
                    "#recoverFlex .accountDrawer--SuccessSpace"
                ).innerHTML = "";
                _this.element.querySelector(
                    "#recoverFlex .accountDrawer--ErrorSpace"
                ).innerHTML = tempDiv.querySelector(
                    "#RecoverEmail-email-error"
                ).innerHTML;
              } else if (responseText.indexOf("recoverSuccess") !== -1) {
                _this.element.querySelector(
                    "#recoverFlex .accountDrawer--ErrorSpace"
                ).innerHTML = "";
                _this.element.querySelector(
                    "#recoverFlex .accountDrawer--SuccessSpace"
                ).innerHTML = tempDiv.querySelector("#recoverSuccess").innerHTML;
              }

              event.target.querySelector(".itemLoader").classList.remove("is-visible");
            } catch (error) {
              console.log(
                  "An error occurred during the account recovery request:",
                  error
              );
            }
          })();
        }
      }, 500); // Check every 500 milliseconds if the CAPTCHA token is available
    } else {
      // hCaptcha does not exist, proceed without hCaptcha
      const requestBody = {
        email: _this.element.querySelector("#RecoverEmail").value // Use _this for class scope
      };

      event.target.querySelector(".itemLoader").classList.add("is-visible");

      // Send the AJAX request without hCaptcha
      (async function () {
        try {
          const response = await fetch(registrationEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseText = await response.text();
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = responseText;

          if (responseText.indexOf("RecoverEmail-email-error") !== -1) {
            _this.element.querySelector(
                "#recoverFlex .accountDrawer--SuccessSpace"
            ).innerHTML = "";
            _this.element.querySelector(
                "#recoverFlex .accountDrawer--ErrorSpace"
            ).innerHTML = tempDiv.querySelector(
                "#RecoverEmail-email-error"
            ).innerHTML;
          } else if (responseText.indexOf("recoverSuccess") !== -1) {
            _this.element.querySelector(
                "#recoverFlex .accountDrawer--ErrorSpace"
            ).innerHTML = "";
            _this.element.querySelector(
                "#recoverFlex .accountDrawer--SuccessSpace"
            ).innerHTML = tempDiv.querySelector("#recoverSuccess").innerHTML;
          }

          event.target.querySelector(".itemLoader").classList.remove("is-visible");
        } catch (error) {
          console.log(
              "An error occurred during the account recovery request:",
              error
          );
        }
      })();
    }
  }



  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = "/account";

    // Check if hCaptcha exists, if yes, execute it
    if (window.hcaptcha) {
      // Manually trigger the hCaptcha
      window.hcaptcha.execute();

      // Add a delay and wait for the CAPTCHA to finish, then retrieve the response
      const interval = setInterval(function () {
        const captchaToken = window.hcaptcha.getResponse(); // Get the hCaptcha token

        if (captchaToken) {
          clearInterval(interval); // Stop checking once the token is available


          // Create the request body with the registration data and hCaptcha token
          const requestBody = {
            customer: {
              first_name: _this.element.querySelector(
                  "#register #RegisterForm-FirstName"
              ).value,
              last_name: _this.element.querySelector(
                  "#register #RegisterForm-LastName"
              ).value,
              email: _this.element.querySelector("#register #RegisterForm-email")
                  .value,
              password: _this.element.querySelector("#register #RegisterForm-password")
                  .value,
            },
            'h-captcha-response': captchaToken // Include the hCaptcha token here
          };

          event.target.querySelector(".itemLoader").classList.add("is-visible");

          // Send the AJAX request
          (async function () {
            try {
              const response = await fetch(registrationEndpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
              });

              const responseText = await response.text();

              if (responseText.indexOf("registerErrors") !== -1) {
                console.log("Error occurred during registration");
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = responseText;

                _this.element.querySelector(
                    "#register .accountDrawer--ErrorSpace"
                ).innerHTML = tempDiv.querySelector(".registerErrors").innerHTML;
              } else {
                location.href = window.routes.account_url;
              }

              event.target
                  .querySelector(".itemLoader")
                  .classList.remove("is-visible");
            } catch (error) {
              console.log(
                  "An error occurred during the registration request:",
                  error
              );
            }
          })();
        }
      }, 500); // Check every 500 milliseconds if the CAPTCHA token is available
    } else {
      // hCaptcha does not exist, proceed without hCaptcha
      const requestBody = {
        customer: {
          first_name: _this.element.querySelector(
              "#register #RegisterForm-FirstName"
          ).value,
          last_name: _this.element.querySelector(
              "#register #RegisterForm-LastName"
          ).value,
          email: _this.element.querySelector("#register #RegisterForm-email")
              .value,
          password: _this.element.querySelector("#register #RegisterForm-password")
              .value,
        }
      };

      event.target.querySelector(".itemLoader").classList.add("is-visible");

      // Send the AJAX request without hCaptcha
      (async function () {
        try {
          const response = await fetch(registrationEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseText = await response.text();

          if (responseText.indexOf("registerErrors") !== -1) {
            console.log("Error occurred during registration");
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = responseText;

            _this.element.querySelector(
                "#register .accountDrawer--ErrorSpace"
            ).innerHTML = tempDiv.querySelector(".registerErrors").innerHTML;
          } else {
            location.href = window.routes.account_url;
          }

          event.target
              .querySelector(".itemLoader")
              .classList.remove("is-visible");
        } catch (error) {
          console.log(
              "An error occurred during the registration request:",
              error
          );
        }
      })();
    }
  }

  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = "/account/login";

    // Check if hCaptcha exists, if yes, execute it
    if (window.hcaptcha) {
      // Manually trigger the hCaptcha
      window.hcaptcha.execute();

      // Add a delay and wait for the CAPTCHA to finish, then retrieve the response
      const interval = setInterval(function () {
        const captchaToken = window.hcaptcha.getResponse(); // Get the hCaptcha token

        if (captchaToken) {
          clearInterval(interval); // Stop checking once the token is available

          // Create the request body with login credentials and hCaptcha token
          const requestBody = {
            customer: {
              email: _this.element.querySelector(
                  "#customer_login #CustomerEmail"
              ).value,
              password: _this.element.querySelector(
                  "#customer_login #CustomerPassword"
              ).value,
            },
            'h-captcha-response': captchaToken // Include the hCaptcha token here
          };

          event.target
              .closest("form")
              .querySelector(".itemLoader")
              ?.classList.add("is-visible");

          // Send the AJAX request
          (async function () {
            try {
              const response = await fetch(loginEndpoint, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
              });

              const responseText = await response.text();

              if (responseText.indexOf("loginError") !== -1) {
                console.log("Incorrect email or password");
                const tempDiv = document.createElement("div");

                tempDiv.innerHTML = responseText;

                _this.element.querySelector(
                    "#login .accountDrawer--ErrorSpace"
                ).innerHTML = `<div class="AlertErrorInner u-p4 pb-m">${
                    tempDiv.querySelector(".AlertError").innerHTML
                }</div>`;
              } else {
                location.href = window.routes.account_url;
              }

              event.target
                  .closest("form")
                  .querySelector(".itemLoader")
                  ?.classList.remove("is-visible");
            } catch (error) {
              console.log("An error occurred during the login request:", error);
            }
          })();
        }
      }, 500); // Check every 500 milliseconds if the CAPTCHA token is available
    } else {
      // hCaptcha does not exist, proceed without hCaptcha
      const requestBody = {
        customer: {
          email: _this.element.querySelector(
              "#customer_login #CustomerEmail"
          ).value,
          password: _this.element.querySelector(
              "#customer_login #CustomerPassword"
          ).value,
        }
      };

      event.target
          .closest("form")
          .querySelector(".itemLoader")
          ?.classList.add("is-visible");

      // Send the AJAX request without hCaptcha
      (async function () {
        try {
          const response = await fetch(loginEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          });

          const responseText = await response.text();

          if (responseText.indexOf("loginError") !== -1) {
            console.log("Incorrect email or password");
            const tempDiv = document.createElement("div");

            tempDiv.innerHTML = responseText;

            _this.element.querySelector(
                "#login .accountDrawer--ErrorSpace"
            ).innerHTML = `<div class="AlertErrorInner u-p4 pb-m">${
                tempDiv.querySelector(".AlertError").innerHTML
            }</div>`;
          } else if (
              responseText.indexOf("shopify-challenge__container") !== -1
          ) {
            location.href = "/challenge";
          } else {
            location.href = window.routes.account_url;
          }

          event.target
              .closest("form")
              .querySelector(".itemLoader")
              ?.classList.remove("is-visible");
        } catch (error) {
          console.log("An error occurred during the login request:", error);
        }
      })();
    }
  }


  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(
        '.accountDrawer--Tab[aria-expanded="true"]'
    );
    const allContent = this.element.querySelectorAll(".accountContent");

    allTabs.forEach((tab) => {
      tab.setAttribute("aria-expanded", "false");
    });

    const dataId = event.target.dataset.id;
    this.element
        .querySelectorAll(`.accountDrawer--Tab[data-id="${dataId}"]`)
        .forEach((el) => el.setAttribute("aria-expanded", "true"));

    allContent.forEach((content) => {
      content.setAttribute("aria-visible", "false");
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }
}

customElements.define("account-handler", AccountHandler);

class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let breakpoint = responsive.getCurrentBreakpoint();
    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    var location = this.element.getAttribute("data-settings");

    if (location == "sidebarMenu") {
      var additionalOverlay = true;
    } else {
      var additionalOverlay = false;
    }
    if (breakpoint != "phone" && breakpoint != "tablet") {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, additionalOverlay);
        });
      }
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.blocks = Array.from(
        this.element.querySelectorAll(".announcement-bar--block")
    );
    this.currentBlockIndex = 0;
    this.transitionSpeed =
        parseInt(this.element.getAttribute("data-settings")) * 1000;
    this.announcementBar = document.querySelector(".announcement-bar");

    document.documentElement.style.setProperty(
        "--announcement-fixed-height",
        this.element.clientHeight + "px"
    );

    this.initBlocks();

    if (
        typeof this.transitionSpeed === "number" &&
        !isNaN(this.transitionSpeed)
    ) {
      if (this.blocks.length > 1) {
        this.startAnimating();
      }
    }
    this.updateVisibleHeight();
    this.updateVisibleHeightListener = this.updateVisibleHeight.bind(this);
    scrollListener.addScrollListener(this, this.updateVisibleHeightListener);
  }

  initBlocks() {
    this.blocks.forEach((block, index) => {
      if (index == 0) {
        block.style.opacity = 1;
        block.style.display = "flex";
      } else {
        block.style.opacity = 0;
        block.style.display = "none";
      }
    });
  }

  updateVisibleHeight() {
    const rect = this.announcementBar.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcement-bar with the visible height

    document.documentElement.style.setProperty(
        "--announcement-dynamic-height",
        `${visibleHeight}px`
    );
  }

  handleBreakpointChange() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.mobile = false;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach(
            (block, i) => (block.style.display = "block")
        );
        this.original.style.justifyContent = "space-between";
      }
    } else {
      this.mobile = true;
      if (this.transitionSpeed) {
        this.duplicateBlockWrappers();
      } else {
        Array.from(this.original.children).forEach((block, i) => {
          if (i != 0) block.style.display = "none";
        });
        this.original.style.justifyContent = "center";
      }
    }
  }

  resetWrapper() {
    Array.from(this.animWrapper.children).forEach((child, i) => {
      if (i != 0) this.animWrapper.removeChild(this.animWrapper.lastChild);
    });
    this.originalNew =
        this.element.offsetWidth -
        parseInt(getComputedStyle(this.element).paddingLeft) * 2;
  }

  duplicateBlockWrappers() {
    this.resetWrapper();
    const duplicate = this.original.cloneNode(true),
        spaceDiv = document.createElement("div");

    var originalWidth = (originalWidth = this.original.offsetWidth);
    if (this.originalNew) originalWidth = this.originalNew;

    if (this.mobile) {
      duplicate.style.width =
          originalWidth * this.original.children.length -
          window.innerWidth +
          "px";
      this.original.style.width =
          originalWidth * this.original.children.length -
          window.innerWidth +
          "px";
      this.animWrapper.style.width =
          2 *
          (originalWidth * this.original.children.length - window.innerWidth) +
          "px";

      if (this.original.children.length >= 2)
        this.spaceDivWidth = this.getDistanceBetweenBlocks(
            this.original.children[0],
            this.original.children[1]
        );
      else this.spaceDivWidth = 0;
    } else {
      if (this.original.children.length >= 2)
        this.spaceDivWidth = this.getDistanceBetweenBlocks(
            this.original.children[0],
            this.original.children[1]
        );
      else this.spaceDivWidth = 0;

      duplicate.style.width = originalWidth + "px";
      this.original.style.width = originalWidth + "px";
      this.animWrapper.style.width =
          2 * originalWidth + this.spaceDivWidth + "px";
    }

    spaceDiv.style.width = this.spaceDivWidth + "px";
    this.animWrapper.style.position = "absolute";
    if (this.mobile && this.firstLoad)
      this.animWrapper.style.transform = `translateX(${
          this.spaceDivWidth / 2
      }px)`;

    this.element.style.height = this.animWrapper.offsetHeight + "px";

    this.animWrapper.appendChild(spaceDiv);
    this.animWrapper.appendChild(duplicate);

    setTimeout(() => {
      this.startAnimating();
    }, 100);
  }

  startAnimating() {
    setInterval(() => {
      this.showNextBlock();
    }, this.transitionSpeed);
  }

  showNextBlock() {
    const currentBlock = this.blocks[this.currentBlockIndex];
    const nextBlockIndex = (this.currentBlockIndex + 1) % this.blocks.length;
    const nextBlock = this.blocks[nextBlockIndex];

    // Fade out current block

    currentBlock.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 500,
      fill: "forwards",
      easing: "ease-out",
    }).onfinish = () => {
      currentBlock.style.display = "none";

      // Show next block
      nextBlock.style.display = "flex";
      nextBlock.animate(
          [
            { opacity: 0, transform: "translateY(10px)" },
            { opacity: 0.2, transform: "translateY(5px)" },
            { opacity: 1, transform: "translateY(0)" },
          ],
          {
            duration: 500,
            fill: "forwards",
            easing: "ease-out",
          }
      );
    };

    this.currentBlockIndex = nextBlockIndex;
  }
}

customElements.define("announcement-bar", AnimatedAnnouncementBar);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = null;
    this.enableSwiperControl = this.element.getAttribute("data-enable-swiper");
    this.paginationContainer = this.element.querySelector(
        ".usp-section__swiper-wrapper"
    );
    this.fallbackSlides = this.element.querySelector("#fallback-slides");

    this.updateIsMobile();
    this.updateSwiperControl();
    this.bindEvents();

    window.addEventListener("resize", () => {
      this.updateIsMobile();
      this.updateSwiperControl();
    });
  }

  bindEvents() {
    this.initSwiper = this.initSwiper.bind(this);
    this.destroySwiper = this.destroySwiper.bind(this);
    this.showSwiper = this.showSwiper.bind(this);
    this.hideSwiper = this.hideSwiper.bind(this);
  }

  updateIsMobile() {
    this.isMobile = responsive.matchesBreakpoint("pocket");
  }

  updateSwiperControl() {
    const slides = this.carouselElement.querySelectorAll(".swiper-slide");
    if (
        this.enableSwiperControl === "true" &&
        this.isMobile &&
        slides.length > 1
    ) {
      this.showSwiper();
      this.initSwiper();
    } else {
      this.destroySwiper();
      this.hideSwiper();
    }
  }

  initSwiper() {
    if (!this.carousel) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  destroySwiper() {
    if (this.carousel) {
      this.carousel.swiperElement.destroy(true, true);
      this.carousel = null;
    }
  }

  showSwiper() {
    this.carouselElement.style.display = "block";
    this.paginationContainer.style.display = "flex";
    this.fallbackSlides.style.display = "none";
  }

  hideSwiper() {
    this.fallbackSlides.style.display = "flex";
    this.carouselElement.style.display = "none";
    this.paginationContainer.style.display = "none";
  }
}

customElements.define("usp-section", UspSection);

class CollectionShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.wrapperElement = this.querySelector(
        ".collection-showcase-small__wrapper"
    );
    this.carousel = this.element.querySelector(".swiper");
    this.swiperElem = new RevolutionSwiper(this.carousel);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.initIntersectionObserver();
  }

  initIntersectionObserver() {
    const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.animateSlides();
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
        }
    );

    observer.observe(this.element);
  }

  animateSlides() {
    const slides = this.swiperElem.swiperElement.slides;

    slides.forEach((slide, index) => {
      slide.style.opacity = 0;
      slide.style.transform = "translateX(30px)";

      setTimeout(() => {
        if (this.breakpoint == "phone" || this.breakpoint == "tablet") {
          const elementMove = [
            { transform: "translateX(30px)", opacity: "0" },
            { transform: "translateX(0)", opacity: "1" },
          ];
          slide.animate(elementMove, {
            duration: window.theme.animationDuration,
            fill: "forwards",
          });
        } else {
          var elementMove = [
            { transform: "translateY(30px)", opacity: "0" },
            { transform: "translateY(0px)", opacity: "1" },
          ];
          slide.animate(elementMove, {
            duration: window.theme.animationDuration,
            fill: "forwards",
          });
        }
        slide.style.opacity = 1;
      }, window.theme.animationBetweenElements * index);
    });
  }
}
customElements.define("collection-showcase-slider", CollectionShowcaseSlider);

class faqSection extends HTMLElement {
  constructor() {
    super();

    // Initialize elements and delegates
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.clicked = false;
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
    // Initialize the observer for scroll events
    this.initObserver();

    // Bind events to the elements
    this.bindEvents();
  }

  // Method to bind events
  bindEvents() {

    this.delegateElement.on(
        "click",
        '[data-action="handle-click"]',
        this.handleClick.bind(this)
    );
  }

  // Method to handle title visibility
  handleTitles() {
    const allTitles = this.element.querySelectorAll(".FAQSubheader--title");
    let firstTitle = true;

    allTitles.forEach((title) => {
      const parent = title.closest(".Faq-Section");
      const showed = parent.querySelector(".supportFaq--showed");

      title.style.display = showed ? "block" : "none";

      if (!showed) {
        parent.style.display = "none";
      }

      if (showed && firstTitle) {
        parent.classList.add("FAQSubheader--firstTitle");
        firstTitle = false;
      }
    });
  }

  // Method to handle click events
  handleClick(event) {
    this.element.dataset.clicked = "true";
    const allLinks = this.element.querySelectorAll(".FaqLinkList__Item");
    allLinks.forEach((item) => {
      item.classList.remove("CurrentLinkPage");
    });
    event.target.classList.add("CurrentLinkPage");
    setTimeout(() => {
      this.element.dataset.clicked = "false";
    }, 200);
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".CurrentLinkPage");
    linkedItems.forEach((item) => {
      item.classList.remove("CurrentLinkPage");
    });
  }

  // Method to initialize the scroll observer
  initObserver() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  // Method to handle scroll events
  handleScroll() {

    if (this.element.dataset.clicked == "true") return;
    const faqSubheaders = this.element.querySelectorAll(".FAQSubheader--main");
    const faqMenuTabsWrapper = this.element.querySelectorAll(
        ".faq--menuTabsWrapper"
    );
    let threshold;
    if (new Responsive().matchesBreakpoint("pocket")) {
      threshold = 50;
    }else{
      threshold = 100;
    }

    if (new Responsive().matchesBreakpoint("pocket")) {

      faqMenuTabsWrapper.forEach((item) => {
        const distanceFromTop = item.getBoundingClientRect().top;
        item.style.boxShadow =
            distanceFromTop <= 52 && distanceFromTop > 0
                ? "0px 4px 12px 0px rgba(20, 20, 20, 0.10)"
                : "none";
      });
    }

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
          0,
          faqSubheader.getBoundingClientRect().top
      );
      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".Faq-Section").id;
        const anchorElements = this.element.querySelectorAll(
            `a[href="#${faqSection}"]`
        );

        anchorElements.forEach((item) => {
          item.classList.add("CurrentLinkPage");

        });
      }
    });
  }
}
customElements.define("faq-section", faqSection);

class ImageTextAnimation extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.imageObserver();
  }

  imageAnimation() {
    const images = this.element.querySelectorAll(".image-container__image");
    images.forEach((image) => {
      image.classList.add("image-animation");
    });
  }

  imageObserver() {
    const settings = { threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.imageAnimation(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, settings);
    observer.observe(this.element);
  }
}
customElements.define("image-text-animation", ImageTextAnimation);

class QuoteAnimation extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.quoteObserver();
  }

  async changeColor(div) {
    const textQuote = div.innerText;
    const lettersQuote = textQuote.split("");

    div.innerHTML = "";

    await new Promise((resolve) => {
      lettersQuote.forEach((letter, index) => {
        const span = document.createElement("span");
        span.innerText = letter;
        div.appendChild(span);

        setTimeout(() => {
          span.style.color = "var(--primary_text)";
          if (index === lettersQuote.length - 1) {
            resolve();
          }
        }, index * 20);
      });
    });
  }

  async changeColorAsync(target) {
    if (!target) return;

    const textElementQuote = target.querySelector(".quote-block__quote");
    await this.changeColor(textElementQuote);

    const textElement = target.querySelector(".quote-block__text");
    this.changeColor(textElement);

    const smallTextElement = target.querySelector(".quote-block__small-text");
    this.changeColor(smallTextElement);
  }

  quoteObserver() {
    const settings = { threshold: 0.5 };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.changeColorAsync(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, settings);

    const slides = this.element.querySelectorAll(".swiper-slide");
    slides.forEach((slide) => {
      observer.observe(slide);
    });
  }
}
customElements.define("quote-animation", QuoteAnimation);

class CollectionBanner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    if (!responsive.matchesBreakpoint("lap_and_up")) {
      // Ensure all CSS and page resources are fully loaded before initializing Swiper
      this.waitForCSSLoad().then(() => {
        this.carouselElement = this.element.querySelector(
            ".collection-banner-links__swiper-mobile .swiper"
        );
        if (this.carouselElement) {
          this.carousel = new RevolutionSwiper(this.carouselElement);
        }
      });
      if (this.carouselElement) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    this.bindEvents();
  }

  // Helper function to wait for all page resources, including CSS, to load
  waitForCSSLoad() {
    return new Promise((resolve) => {
      if (document.readyState === "complete") {
        resolve();
      } else {
        window.addEventListener("load", resolve);
      }
    });
  }

  bindEvents() {}
}
customElements.define("collection-banner", CollectionBanner);

class SectionTerms extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const container = this.element.querySelector("#text-block-container");
    const blocks = container.querySelectorAll(".tc-layout__wrapper_text-block");

    let currentGroup = null;

    blocks.forEach((block, index) => {
      const hasHeading = block.getAttribute("data-has-heading") === "true";

      if (hasHeading) {
        if (currentGroup) {
          container.appendChild(currentGroup);
        }

        currentGroup = document.createElement("div");
        currentGroup.classList.add("tc-layout__text-wrapper");
        currentGroup.appendChild(block);
      } else {
        if (!currentGroup) {
          if (index === 0) {
            currentGroup = document.createElement("div");
            currentGroup.classList.add("tc-layout__text-wrapper");
            container.appendChild(currentGroup);
          }
        }

        if (currentGroup) {
          currentGroup.appendChild(block);
        } else {
          container.appendChild(block);
        }
      }
    });

    if (currentGroup) {
      container.appendChild(currentGroup);
    }
  }
}

customElements.define("section-terms", SectionTerms);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this._mo = null;
    this._onQty = null;
    this._onRerender = null;
    this._onCustomerType = null;

    if (this.options["showRecommendations"]) {
      this.loadRecommendations();
    }

    new AddToCart(this.element);
  }

  connectedCallback() {
    // run once on page load
    this.updateCartMonthlyRate();

    // try to hook into existing theme events
    this._onQty = () => this.updateCartMonthlyRate();
    this._onRerender = () => this.updateCartMonthlyRate();
    this._onCustomerType = () => this.updateCartMonthlyRate();

    document.addEventListener("quantity:changed", this._onQty);
    document.addEventListener("cart:rerendered", this._onRerender);
    document.addEventListener("cart:updated", this._onRerender);
    document.addEventListener("customer-type:changed", this._onCustomerType);

    // scoped observer fallback (NOT document.body)
    const totalsRoot =
        this.element.querySelector(".CartFooter--Totals") ||
        document.querySelector(".CartFooter--Totals") ||
        this.element;

    this._mo = new MutationObserver(() => {
      clearTimeout(this._mo._t);
      this._mo._t = setTimeout(() => this.updateCartMonthlyRate(), 50);
    });

    this._mo.observe(totalsRoot, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    if (this._mo) this._mo.disconnect();
    if (this._onQty) document.removeEventListener("quantity:changed", this._onQty);
    if (this._onRerender) {
      document.removeEventListener("cart:rerendered", this._onRerender);
      document.removeEventListener("cart:updated", this._onRerender);
    }
    if (this._onCustomerType) document.removeEventListener("customer-type:changed", this._onCustomerType);

    this._mo = null;
    this._onQty = null;
    this._onRerender = null;
    this._onCustomerType = null;
  }

  updateCartMonthlyRate() {
    const rateEl = document.querySelector("[data-cart-rate]");
    if (!rateEl) return;

    const months = parseInt(rateEl.getAttribute("data-months") || "0", 10);
    if (!Number.isFinite(months) || months <= 0) return;

    // IMPORTANT: pick the cart page total node that has data-price-cents
    const totalNode =
        document.querySelector(".CartFooter--Totals .price-cart-footer[data-price-cents]") ||
        document.querySelector("[data-cart-total][data-price-cents]") ||
        document.querySelector(".cart-total[data-price-cents]");

    if (!totalNode) return;

    const totalCents = parseInt(totalNode.getAttribute("data-price-cents") || "0", 10);
    if (!Number.isFinite(totalCents) || totalCents <= 0) {
      rateEl.textContent = "";
      return;
    }

    const monthlyCents = Math.round(totalCents / months);

    rateEl.textContent = window.Shopify?.formatMoney
        ? window.Shopify.formatMoney(monthlyCents, window.theme?.moneyFormat)
        : (monthlyCents / 100).toFixed(2);
  }

  loadRecommendations() {
    // unchanged...
  }
}

customElements.define("cart-items", CartItems);


class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.allNotifications = this.element.querySelectorAll(
        ".product-module__notify-action"
    );
    this.emailContainer = this.element.querySelector(
        "#product-module__notify-me-input"
    );
    this.subtitle = this.element.querySelector(".product-module__notify-text");
    this.productId = document.querySelector(
        'form[data-product-form] [name="id"]'
    ).dataset.productid;

    this.variantId = document.querySelector(
        '[name="notify_variant"]'
    ).dataset.id;

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
        "click",
        '[data-action="notify-open"]',
        this.openNotifyMe.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="subscribe"]',
        this.handleSubscribe.bind(this)
    );
    this.delegateBody.on(
        "click",
        '[data-action="notify-close-success"]',
        this.closeNotifyMeSuccess.bind(this)
    );
    this.delegateBody.on("notify:change", this.updateVariantId.bind(this));
    this.delegateElement.on(
        "click",
        '[data-action="notify-close"]',
        this.closeNotifyMe.bind(this)
    );
  }

  updateVariantId(e) {
    this.variantId = e.detail.id;
  }

  handleSubscribe() {
    const email = this.element.querySelector('[name="notify_email"]').value;
    let promise = SI.create(email, this.variantId, this.productId);

    if (email !== "" && email.includes("@")) {
      promise.then((st, data) => {
        let resp = SI.parseJSON(data);
        if (resp.status == "OK") {
          this.showNotification("success");
        } else {
          this.showNotification("error");
        }
      });
    } else {
      this.showNotification("email-error");
    }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
        el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "success":
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--success"
        );
        let activeBtn = this.element.querySelector(
            ".product-module__notify-button--success"
        );
        let subsBtn = this.element.querySelector(
            ".product-module__notify-button--subscribe"
        );
        subsBtn.style.display = "none";
        activeBtn.setAttribute("aria-hidden", "false");
        activeNotification.setAttribute("aria-hidden", "false");
        this.emailContainer.style.display = "none";
        this.subtitle.style.display = "none";
        break;

      case "email-error":
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
            ".product-module__notify-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

  openNotifyMe(e) {
    e.preventDefault();
    this.element.setAttribute("aria-hidden", "false");
    trapFocus(this.element);

    this.pageOverlayElement.classList.add("is-visible");
    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

    this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
    );
  }

  closeNotifyMe(e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );

    // Remove scrolllock and clear notifications after the popup disappears so there are no visible layout shifts
    this.element.addEventListener(
        "transitionend",
        () => {
          if (e.target.closest('[data-action="notify-close"]')) {
            setTimeout(() => {
              bodyScrollLock.enableBodyScroll(
                  this.element,
                  bodyScrollLockOptions
              );
              this.clearNotifications();
            }, 50);
          } else {
            bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
            this.clearNotifications();
          }
        },
        { once: true }
    );
  }

  closeNotifyMeSuccess (e) {
    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
    );

    this.element.addEventListener(
        "transitionend",
        () => {
          if (e.target.closest('[data-action="notify-close"]')) {
            setTimeout(() => {
              bodyScrollLock.enableBodyScroll(
                  this.element,
                  bodyScrollLockOptions
              );
            }, 50);
          } else {
            bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
          }
        },
        { once: true }
    );
  }
}

customElements.define("notify-me-popup", NotifyMe);

class VatController extends HTMLElement {
  constructor() {
    super();

    this.KEY = 'customer_type';

    this.isRendering = false;
    this.mt = null;

    this.delegate = null;
    this.observer = null;
    this.onVariantChange = null;
    this.onResize = null;

    let pct = parseFloat(window.theme?.vat?.ratePercent ?? 0);
    if (!isFinite(pct) || pct < 0) pct = 0;
    if (pct > 100) pct = 100;

    this.vatRate = pct / 100;
    this.includeTax = !!window.theme?.vat?.customerLoggedIn;

    this.defaultType = 'private';
    this.currentType = localStorage.getItem(this.KEY) || this.defaultType;

    this.responsive = window.theme?.responsive || (window.theme.responsive = new Responsive(true));
    this.resizeSubscription = null;


    this.applyDiscountOnLogin();
  }

  connectedCallback() {

    this.cleanup();
    this.applyType(this.currentType);

    // Delegated radio handling (ONLY sync the active picker)
    this.delegate = new Delegate(document.body);
    this.delegate.on('change', 'input[name="customer_type"]', (e) => {
      const next = e?.target?.value;
      if (!next || next === this.currentType) return;
      this.applyType(next, true);
    });

    this.onVariantChange = () => this.renderAllPrices();
    document.addEventListener('variant:change', this.onVariantChange);
    this.applyDiscountOnLogin();
    this.observer = new MutationObserver((mutations) => {
      if (this.isRendering) return;

      let relevant = false;

      for (let i = 0; i < mutations.length; i++) {
        const m = mutations[i];

        if (m.addedNodes && m.addedNodes.length) {
          for (let j = 0; j < m.addedNodes.length; j++) {
            const n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;

            if (
                n.matches?.('[data-vat-price][data-price-cents]') ||
                n.querySelector?.('[data-vat-price][data-price-cents]') ||
                n.matches?.('input[name="customer_type"]') ||
                n.querySelector?.('input[name="customer_type"]') ||
                n.matches?.('.vat-label') ||
                n.querySelector?.('.vat-label')
            ) {
              relevant = true;
              break;
            }
          }
        }

        if (relevant) break;
      }

      if (!relevant) return;

      clearTimeout(this.mt);
      this.mt = setTimeout(() => {
        this.syncRadiosResponsive();
        this.syncVatLabels();
        this.renderAllPrices();
      }, 120);
    });



    const roots = [
      document.querySelector('main'),
      document.querySelector('[data-vat-picker="desktop"]'),
      document.querySelector('[data-vat-picker="mobile"]')
    ].filter(Boolean);

    (roots.length ? roots : [document.body]).forEach((root) => {
      this.observer.observe(root, { childList: true, subtree: true });
    });


    // subscribe once (even if disconnectedCallback never fires)
    if (!this.resizeSubscription) {
      this.resizeSubscription = this.responsive.addResizeListener(this, function () {
        clearTimeout(this.mt);
        this.mt = setTimeout(() => this.syncRadiosResponsive(), 80);
      });
    }

    window.addEventListener('resize', this.onResize);

    this.syncRadiosResponsive();
    this.syncVatLabels();
  }

  cleanup() {
    if (this.resizeSubscription) {
      this.resizeSubscription.removeResizeListener();
      this.resizeSubscription = null;
    }

    if (this.delegate) {
      this.delegate.destroy();
      this.delegate = null;
    }

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.mt) {
      clearTimeout(this.mt);
      this.mt = null;
    }

    if (this.onVariantChange) {
      document.removeEventListener('variant:change', this.onVariantChange);
      this.onVariantChange = null;
    }
  }

  applyDiscountOnLogin = () => {

    const code = (window.theme?.vat?.discountCode || '').trim();
    const loggedIn = window.theme?.vat?.customerLoggedIn !== '';
    const isBusiness = this.currentType === 'business';

    const KEY = 'b2b_discount_applied_code';

    if (!loggedIn || !code) return;
    localStorage.setItem(KEY, code);

    if(localStorage.getItem("DONE") === "true") return;
    const redirect = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${redirect}`;
    localStorage.setItem("DONE", true);
  };


  isDesktop() {
    return (
        typeof responsive !== 'undefined' &&
        typeof responsive.matchesBreakpoint === 'function' &&
        responsive.matchesBreakpoint('lap_and_up')
    );
  }

  // Update ONLY the currently visible picker (desktop OR mobile), not both
  syncRadiosResponsive() {
    const isDesktop = this.isDesktop();
    let scope = null;

    const desktopWrap = document.querySelector('[data-vat-picker="desktop"]');
    const mobileWrap = document.querySelector('[data-vat-picker="mobile"]');

    if (desktopWrap && mobileWrap) {
      scope = isDesktop ? desktopWrap : mobileWrap;
    }

    const radios = scope
        ? scope.querySelectorAll('input[name="customer_type"]')
        : this.getVisibleRadiosFallback();

    radios.forEach((r) => {
      const should = r.value === this.currentType;
      if (r.checked !== should) r.checked = should;
    });
  }

  // fallback: pick only radios that are actually visible
  getVisibleRadiosFallback() {
    const all = Array.from(document.querySelectorAll('input[name="customer_type"]'));

    const visible = all.filter((r) => {
      const el = r.closest('label') || r;
      const rect = el.getBoundingClientRect();
      const cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    });

    if (visible.length) return visible;
    return all;
  }

  applyType(type, isChange) {

    const loggedIn = !!window.theme?.vat?.customerLoggedIn;
    const customerDiscount = !!window.theme?.vat?.customerDiscount;

    if (loggedIn && !isChange && customerDiscount) {
      type = 'business';
    }

    this.currentType = type || this.defaultType;

    localStorage.setItem(this.KEY, this.currentType);
    document.documentElement.setAttribute('data-customer-type', this.currentType);



    this.syncRadiosResponsive();
    this.syncVatLabels();
    this.renderAllPrices();
    this.applyDiscountOnLogin();


  }

  syncVatLabels() {
    const inc = document.querySelectorAll('.vat-label--inc');
    const ex = document.querySelectorAll('.vat-label--ex');

    const showInc = this.currentType === 'private';
    const showEx = this.currentType === 'business';

    inc.forEach((el) => (el.style.display = showInc ? '' : 'none'));
    ex.forEach((el) => (el.style.display = showEx ? '' : 'none'));
  }

  isCompareAtNode(node) {
    if (node.hasAttribute('data-vat-no-discount')) return true;

    // Common compare-at identifiers in your theme
    return (
        node.classList.contains('ProductInfo--CompareAtPrice') ||
        !!node.closest('.ProductInfo--CompareAtPrice') ||
        node.classList.contains('js-pdp-compare') ||
        !!node.closest('.js-pdp-compare') ||
        node.hasAttribute('data-compare-price') ||
        node.hasAttribute("js-vat-compare") ||
        !!node.closest('.js-pdp-compare') ||
        node.dataset.role === 'compare' || node.hasAttribute('data-vat-no-discount')
    );
  }

  isCartPriceNode(node) {
    return !!node.closest('.cart_item_price, .CartFooter--Totals, .side-cart_price_total');
  }

  renderAllPrices() {
    if (this.isRendering) return;
    this.isRendering = true;

    try {
      let discountPercent = parseFloat(
          window.theme?.vat?.customer_discount ?? window.theme?.vat?.customerDiscount ?? 0
      );

      if (!isFinite(discountPercent) || discountPercent < 0) discountPercent = 0;
      if (discountPercent > 100) discountPercent = 100;

      const discountFactor = 1 - (discountPercent / 100);

      document
          .querySelectorAll('[data-vat-price][data-price-cents]')
          .forEach((node) => {
            const base = parseInt(node.dataset.priceCents, 10);
            if (!isFinite(base)) return;

            // PRIVATE → always original Shopify price
            if (this.currentType === 'private') {
              const nextText = this.formatMoney(base);
              if (node.textContent !== nextText) {
                node.textContent = nextText;
              }
              return;
            }

            // BUSINESS
            let value = base;

            // 1️⃣ Remove VAT (assuming storefront price includes VAT)
            if (this.vatRate > 0) {
              value = Math.round(value / (1 + this.vatRate));
            }

            // 2️⃣ Apply discount ONLY if:
            // - not compare-at
            // - not cart price
            const isCompareAt = this.isCompareAtNode(node);
            const isCartPrice = this.isCartPriceNode(node);

            const allowDiscount =
                discountPercent > 0 &&
                !isCompareAt &&
                !isCartPrice;

            if (allowDiscount) {
              value = Math.round(value * discountFactor);
            }

            const nextText = this.formatMoney(value);
            if (node.textContent !== nextText) {
              node.textContent = nextText;
            }
          });
    } finally {
      this.isRendering = false;

      document.dispatchEvent(
          new CustomEvent('customer-type:changed', {
            bubbles: false,
            detail: {
              type: this.currentType,
            }
          })
      );
    }
  }





  formatMoney(cents) {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
    return (cents / 100).toFixed(2);
  }
}

customElements.define('vat-controller', VatController);


class CalculatorPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector('.pageOverlay');

    this.monthlyRate = 0;
    this.totalMonths = 0;

    this.bindEvents();

    this.updateMonthlyPrices();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeCalculatorPopup.bind(this);

    this.delegateBody.on('click', '[data-action="calculator-open"]', this.openCalculator.bind(this));
    this.delegateElement.on('click', '[data-action="calculator-close"]', this.closeCalculatorPopup.bind(this));

    this.delegateElement.on('input', '.calculator-range', this.onSyncInput.bind(this));
    this.delegateElement.on('input', '.calculator-popup_input', this.onSyncInput.bind(this));

    this.delegateElement.on('change', '.calculator-popup_input', this.onNormalizeInput.bind(this));

    this.delegateElement.on('click', '[data-action="calculate-rate"]', this.calculateRate.bind(this));

    document.addEventListener(
        'customer-type:changed',
        this.updateMonthlyPrices.bind(this)
    );

    document.addEventListener('prices:changed', this.updateMonthlyPrices.bind(this))
  }

  calculateRate(){
    const monthsElem = this.element.querySelector('[data-num="months"]');
    const feeElem = this.element.querySelector('[data-num="fee"]');

    const monthElem = document.querySelector('.js-months');

    const target = document.querySelectorAll('[data-monthly-price]');

    target.forEach((el) => {
      el.innerText = this.monthlyRate;
    })


    if (monthElem) {
      const tpl = monthElem.dataset.template || '';
      const label = tpl
          .replace('{{num}}', this.totalMonths)
      monthElem.textContent = `${label}`
    }

    this.closeCalculatorPopup(true)
  }

  parseMoneyNumber(text) {
    let value = text.replace(/[^\d.,-]/g, '');
    const hasComma = value.includes(',');
    const hasDot = value.includes('.');

    if (hasComma && hasDot) {
      if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
        value = value.replace(/\./g, '').replace(',', '.');
      } else {
        value = value.replace(/,/g, '');
      }
    } else if (hasComma && !hasDot) {
      const parts = value.split(',');
      if (parts[1]?.length === 3) {
        value = parts.join('');
      } else {
        value = value.replace(',', '.');
      }
    } else if (hasDot && !hasComma) {
      const parts = value.split('.');
      if (parts[1]?.length === 3) {
        value = parts.join('');
      }
    }

    return Number(value);
  }

  updateMonthlyPrices() {
    const element = document.querySelectorAll("[data-monthly-price]");
    const elemTotal = document.querySelector("[data-total-price]");
    const raw = elemTotal.textContent;

    console.log("i am raw", raw)
    const defaultMonths = element[0].dataset.months;
    const cents = Math.round(this.parseMoneyNumber(raw) * 100);
    const monthRateCents = Math.round(cents / defaultMonths);

    element.forEach((el) => {
      el.innerText = `${this.formatMoney(monthRateCents)}`;
    })
  }

  resetCalculatorInputs() {
    const inputs = this.element.querySelectorAll('[data-default]');

    inputs.forEach((input) => {
      input.value = input.dataset.default;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (typeof this.recalculate === 'function') {
      this.recalculate();
    }
  }

  recalculate() {
    const monthsElem = this.element.querySelector('[data-num="months"]');
    const targetElement = this.element.querySelector('[data-role="monthly-output"]');
    const priceControl = this.element.querySelector('.calculator-control[data-total-price]');

    if (!monthsElem || !priceControl || !targetElement) return;

    const months = parseInt(monthsElem.value || '0', 10);
    const totalPriceCents = parseInt(priceControl.dataset.totalPrice || '0', 10);

    const elemTotal = document.querySelector("[data-total-price]");
    const raw = elemTotal.textContent;

    const cents = Math.round(this.parseMoneyNumber(raw) * 100);

    if (!Number.isFinite(months) || months <= 0) return;
    if (!Number.isFinite(totalPriceCents) || totalPriceCents <= 0) return;

    const feeElem = this.element.querySelector('[data-num="fee"]');
    let feePercent = 0;

    if (feeElem) {
      const v = parseFloat(feeElem.value || '0');
      feePercent = Number.isFinite(v) ? v : 0;
    }

    if (feePercent < 0) feePercent = 0;
    if (feePercent > 100) feePercent = 100;

    const feeCents = Math.round(cents * (feePercent / 100));
    const financedCents = Math.max(0, cents - feeCents);
    const monthRateCents = Math.round(financedCents / months);

    targetElement.textContent = `${this.formatMoney(monthRateCents)}`;

    this.monthlyRate = this.formatMoney(monthRateCents);
    this.totalMonths = months;
  }

  formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  onNormalizeInput(e) {
    const number = e.target;
    if (!number.classList.contains('calculator-popup_input')) return;

    const group = number.closest('.calculator-control');
    if (!group) return;

    const range = group.querySelector('.calculator-range');
    if (!range) return;

    const min = parseFloat(range.min || '0');
    const max = parseFloat(range.max || '999999');

    let v = parseFloat(number.value || min);
    if (!isFinite(v)) v = min;

    v = Math.min(max, Math.max(min, v));

    number.value = String(v);
    range.value = String(v);
  }

  onSyncInput(e) {
    const el = e.target;
    const group = el.closest('.calculator-control');
    if (!group) return;

    const number = group.querySelector('.calculator-popup_input');
    const range = group.querySelector('.calculator-range');
    if (!number || !range) return;

    const isNumber = el.classList.contains('calculator-popup_input');
    const isRange = el.classList.contains('calculator-range');

    if (isRange) {
      number.value = range.value;
    } else if (isNumber) {
      range.value = number.value;
    }

    if (group.hasAttribute('data-total-price')) {
      const percent = parseFloat(range.value || '0');

      const feeLabel = group.querySelector('.fee-percent');
      if (feeLabel) feeLabel.textContent = `(${isFinite(percent) ? percent : 0}%)`;

      const baseCents = parseInt(group.dataset.totalPrice || '0', 10);
      if (isFinite(baseCents)) {
        const increasedCents = Math.round(baseCents * ((isFinite(percent) ? percent : 0) / 100));

        const priceInput = group.querySelector('[data-role="calculated-price"]');
        if (priceInput) priceInput.value = (increasedCents / 100).toFixed(2);

        group.dataset.feeCents = String(increasedCents);
      }
    }

    this.recalculate();
  }

  openCalculator() {
    this.element.setAttribute('aria-hidden', 'false');
    trapFocus(this.element);

    this.pageOverlayElement?.classList.add('is-visible');

    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
    this.pageOverlayElement?.addEventListener('click', this.onClickOutsideListener);
  }

  closeCalculatorPopup(isButton = false) {
    this.element.setAttribute('aria-hidden', 'true');
    this.pageOverlayElement?.classList.remove('is-visible');
    this.pageOverlayElement?.removeEventListener('click', this.onClickOutsideListener);


    if(!isButton){
      this.resetCalculatorInputs();
    }

    bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
  }
}

customElements.define('calculator-popup', CalculatorPopup);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;

            const recommendations = html.querySelector("product-recommendations");
            if (!recommendations || !recommendations.innerHTML.trim().length) return;

            // Inject fetched markup
            this.innerHTML = recommendations.innerHTML;

            // Re-init everything that relies on DOM nodes
            new AddToCart(this); // <-- this is the important bit

            const swiperEl = this.querySelector(".swiper");
            if (swiperEl) new RevolutionSwiper(swiperEl);

            const limitEl = this.querySelector(".featured-collection__limit");
            if (limitEl) limitEl.style.opacity = 1;

            // If RevolutionAnimation needs a root, pass it
            if (window.theme?.enableAnimations) {
              new RevolutionAnimation(this);
            }
          })
          .catch(console.error);
    };

    new IntersectionObserver(handleIntersection, {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);


